import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {
  LfsaBotonEditarGridComponent
} from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import {CommonFormService} from 'src/app/shared/utils/common-form.service';
import {UtilsService} from 'src/app/shared/utils/utils.service';
import {moduloVMI} from '../../../diccionarios/moduloVMI';
import {VmiArticulosService} from '../../../services/administracion/vmi-articulos.service';
import {AG_GRID_LOCALE_ES} from '../../../diccionarios/spanishAgGrid';
import {ArticuloModel} from '../../../models/vmi-articuloModel';
import { VmiUsuIntegraService } from '../../../services/administracion/vmi-mantenedor-integrador.service';
import { ClienteModel } from '../../../models/vmi-clienteModel';
import { VmiClientesService } from '../../../services/administracion/vmi-clientes.service';
import { UsuarioIntegradorModel } from '../../../models/vmi-usuarioIntegrador';

@Component({
  selector: 'app-vmi-frm-mantenedor-integrador',
  templateUrl: './vmi-frm-mantenedor-integrador.component.html',
  styleUrls: ['./vmi-frm-mantenedor-integrador.component.css']
})
export class VmiFrmMantenedorIntegradorComponent implements OnInit {

  formulario: FormGroup;

  cmbCliente:any[];

  columnDefs: any[];
  rowData: any[] = [];
  frameworkComponents: any;
  gridApi: any;
  gridColumnApi: any;
  rowSelection: any;
  loading: boolean = false;
  listaVacia: boolean = true;

  textBoton: string;
  textoBuscar: string;
  mostrarFormulario: boolean = false;

  modulo: any = {};
  editableForm: boolean = false;

  DAT_TITULOS: any;
  titulo: any;
  AG_GRID_LOCALE_ES: any = {};

  constructor(
    private fb: FormBuilder,
    private _utils: UtilsService,
    private commonFormService: CommonFormService,
    private _articulos: VmiArticulosService,
    private _usuIntegrator: VmiUsuIntegraService,
    private _cliente: VmiClientesService
  ) {
  }

  ngOnInit(): void {
    this.modulo = moduloVMI;
    this.textBoton = this.modulo.button.buttonsNombre.guardar;
    this.AG_GRID_LOCALE_ES = AG_GRID_LOCALE_ES;
    this.DAT_TITULOS = this.modulo.titulos.integrador;
    this.titulo = this.DAT_TITULOS.tituloCardListar;

    this.formulario = this.fb.group({
      cedula: ['',[Validators.required]],
      nombres: ['', [Validators.required]],
      cliId: ['', [Validators.required]]
    });

    this.gridComponent();
    this.getAllCliente();
    this.getAll();
  }

  getAllCliente() {
    this._cliente.getAll().subscribe((res: ClienteModel[]) => {
      this.cmbCliente = res;
    }, (err) => {
      this.cmbCliente = [];
    });
  }

  //*SERVICIOS
  getAll() {
    this._usuIntegrator.getAll().subscribe((res: any[]) => {
      this.loading = false;
      this.rowData = res;
      this.listaVacia = (this.rowData.length === 0) ? true : false;
    }, (err) => {
      console.log(err);
      this.loading = false;
      this.rowData = [];
      this.listaVacia = true;
    });
  }

  gridComponent() {
    this.columnDefs = [
      {
        headerName: 'IdCliente',
        field: 'cliId',
        sortable: true,
        filter: true,
        width: 130
      },
      {
        headerName: 'Usuario Kosmos',
        field: 'loginKosmos',
        sortable: true,
        filter: true,
        width: 150
      },
      {
        headerName: 'Nombre Cliente VMI',
        field: 'nombreCliente',
        sortable: true,
        filter: true,
        resizable: true,
        width: 230
      },
      {
        headerName: 'Estado',
        field: 'estado',
        sortable: true,
        filter: true,
        width: 170,
        valueGetter: function (data) {
          return data.data.estado === 1 ? 'ACTIVO' : 'INACTIVO';
        }
      },
      {
        headerName: 'Fecha creación',
        field: 'fechaRegistro',
        sortable: true,
        filter: true,
        width: 200
      },
      /*{
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 100,
        cellRendererParams: {
          onClick: this.editar.bind(this),
          label: this.modulo.button.buttonsNombre.editar,
          colorBoton: this.modulo.button.buttonsCss.info
        }
      },*/
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 100,
        cellRendererParams: {
          onClick: this.eliminar.bind(this),
          label: this.modulo.button.buttonsNombre.eliminar,
          colorBoton: this.modulo.button.buttonsCss.danger
        }
      }
    ];
    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };
    this.rowSelection = 'multiple';
  }

  onQuickFilterChanged() {
    this.gridApi.setQuickFilter(this.textoBuscar);
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  nuevo() {
    this.commonFormService.abrirFormularioParaGuardar(this);
    this.titulo = this.DAT_TITULOS.tituloCardGuardar;
  }

  editar({rowData}) {
    const obj: ArticuloModel = {
      artId: rowData.artId,
      artDescripcion: rowData.artDescripcion === undefined ? '' : rowData.artDescripcion,
      artUndStock: rowData.artUndStock === undefined ? '' : rowData.artUndStock,
      artCodigoInterno: rowData.artCodigoInterno === undefined ? '' : rowData.artCodigoInterno,
      artCont: rowData.artCont === undefined ? '' : rowData.artCont,
      artEstado: rowData.artEstado === undefined ? '' : rowData.artEstado,
    };
    this.commonFormService.abrirFormularioParaEditar(this, obj);
    this.titulo = this.DAT_TITULOS.tituloCardEditar
  }

  eliminar({rowData}) {
    this._utils.confirmarSincronoPromesa({
      title: this.modulo.mensajes.eliminar,
      text: ``,
      action: this.modulo.button.buttonsNombre.eliminar,
      funcion: this._usuIntegrator.delete(rowData.cliId,rowData.loginKosmos),
    }).then((res: any) => {
      this.getAll();
    }).catch((err) => {
      console.log(err);
    });
  }

  acciones(event) {
    if (event === 'guardar') {
      this.guardar();
      /*if (this.editableForm) {
        this.actualizar();
      } else {
        this.guardar();
      }*/
    } else {
      this.regresar();
    }
  }

  guardar() {
    const cliente:UsuarioIntegradorModel = new UsuarioIntegradorModel(this.formulario.get('cliId').value,this.formulario.get('cedula').value);
    this._utils.confirmarSincronoPromesa({
      title: this.modulo.mensajes.guardar,
      text: ``,
      action: this.modulo.button.buttonsNombre.guardar,
      funcion: this._usuIntegrator.create(cliente),
    }).then((res: any) => {
      this.getAll();
      this.regresar();
    }).catch((err) => {
      console.log(err);
    });
  }

  actualizar() {
    const articulo = new ArticuloModel(this.formulario.value);
    this._utils.confirmarSincronoPromesa({
      title: this.modulo.mensajes.actualizar,
      text: ``,
      action: this.modulo.button.buttonsNombre.actualizar,
      funcion: this._articulos.edit(articulo),
    }).then((res: any) => {
      this.getAll();
      this.regresar();
    }).catch((err) => {
      console.log(err);
    });
  }

  regresar() {
    this.titulo = this.DAT_TITULOS.tituloCardListar;
    this.commonFormService.limpiarYregrear(this);
  }

  buscar(){
    this.loading = true;
    this._usuIntegrator.findClienteKosmos(this.formulario.get('cedula').value).subscribe((res: any) => {
      this.loading = false;
      this.formulario.get('nombres').setValue(res.firstName+' '+res.lastName);
      console.log(res);
    }, (err) => {
      console.log(err);
      this.loading = false;
    });
  }

}
